import React from 'react';
import './Integration.scss';
import ContentLoader from 'react-content-loader';
import IntHeader from './IntHeader';
// import ReactTooltip from 'react-tooltip';
// import { IconInformation } from '../../img';

const Capterra = ({
  data,
  hideShowDataSource,
  // arrDataSource,
  // handleDataSource,
  userIntegration,
  createCapterra,
  deleteCapterra,
  handleStateChangeInt,
  validator,
  // hideShowIntegration,
  openReviewModel,
  // syncReviews,
  intInterValFn,
  loading
}) => {
  if (userIntegration && userIntegration.length > 0) {
    userIntegration.filter(x => {
      if (x.inm === 'capterra') {
        if (x.d && x.d.isListen === true && data.isCallInterVal === false) {
          intInterValFn();
        }
        return x;
      }
    });
  }
  return (
    <div>
      <div className="title-dataset-select">
        {/* <div className="dataset-select-header" >
          <svg onClick={() => hideShowDataSource()} className="link-svg" xmlns="http://www.w3.org/2000/svg" width="12" height="20" viewBox="0 0 12 20">
            <path id="collsapn-arrow" d="M11.587,10.928,2.565,19.951a1.111,1.111,0,0,1-1.568,0l-.665-.665a1.111,1.111,0,0,1,0-1.568L7.909,10.14.324,2.557a1.111,1.111,0,0,1,0-1.568L.988.324a1.111,1.111,0,0,1,1.568,0l9.03,9.03a1.12,1.12,0,0,1,0,1.574Z" transform="translate(11.894 20) rotate(-177)" fill="#8FA7C4" />
          </svg>
          <div className="title-dataset-label cursor" onClick={() => hideShowDataSource()}>
            <img className="mr-2" src={data.img} alt="icon" />
            <h6>{data.dn}</h6>
          </div>
        </div> */}
        <IntHeader
          data={data}
          hideShowDataSource={hideShowDataSource}
        />
        {/* {userIntegration && userIntegration.length > 0 && data.isHideShowInt == false && <div className="integr-inside-hdright" onClick={() => hideShowIntegration()}>
          <div className="add-integra-btn text-center" >
            <a className="nf-btn tbl-seehty-btn">Add New</a>
          </div>
        </div>}
        {((typeof userIntegration == 'undefined' || typeof userIntegration == 'boolean') || (data.isHideShowInt == true)) && <div className="wdgt-group-block wdgt-group-ggplace">
          <div className="wdgt-group-input mt-25">
            <label>URL</label>
            <input className="nf-input nf-input-sm" name="curl" placeholder="Enter URL" value={data.curl} onChange={handleStateChangeInt} />
            {validator.message('url', data.curl, 'required|required')}
          </div>
          <div className="wdgt-group-input mt-15">
            <label>Enter Company name</label>
            <input className="nf-input nf-input-sm" name="rmk" value={data.rmk} placeholder="Enter Company name" onChange={handleStateChangeInt} />
            {validator.message('connection', data.rmk, 'required|required')}
          </div>
          <div className="add-integra-btn text-center" onClick={(e) => createCapterra(e)}>
            <a className="nf-btn nf-btn-default">Add New</a>
          </div>
        </div>} */}
        <div className="wdgt-group-block wdgt-dataset-form  wdgt-group-ggplace">
          <div className="wdgt-group-input mt-15">
            <label>URL</label>
            <input className="nf-input nf-input-sm" name="curl" placeholder="Enter Capterra URL" value={data.curl} onChange={handleStateChangeInt} />
            {validator.message('url', data.curl, 'required|required')}
            <p style={{ fontSize: '12px', color: '#212121' }}>e.g. https://www.capterra.com/p/200592/WiserNotify/reviews/</p>
          </div>
          <div className="wdgt-group-input mt-15">
            <label>Enter Company name</label>
            <input className="nf-input nf-input-sm" name="rmk" value={data.rmk} placeholder="Enter Company name" onChange={handleStateChangeInt} />
            {validator.message('Company name', data.rmk, 'required|required')}
          </div>
          <div className="add-integra-btn text-center" onClick={(e) => createCapterra(e)}>
            <a className="nf-btn nf-btn-default">Add New</a>
          </div>
        </div>
        {/* {userIntegration && userIntegration.length > 0 && <div className="integre-search--list">
          <input
            className="nf-input nf-input-sm input-left-inicon input-left-iconsearch input-left-visitor"
            placeholder="Search by name"
            type="text"
            name="searchByName"
            value={data.searchByName}
            onChange={(e) => handleStateChangeInt(e)}
          />
        </div>} */}
        {loading === true ?
          <ContentLoader
            height={750}
            width={1750}
            speed={2}
            primaryColor="#fff"
            secondaryColor="#eceef4"
          >
            <rect x="150" y="40" rx="0" ry="0" width="1500" height="700"></rect>
          </ContentLoader>
          :
          <div className='sublistapp-connect-block'>
            <h5 className='title-connection'>Company list</h5>
            <div className='app-list-sublistapp'>
              <div className='integra-data-headerblock'>
                <label className=''>Name</label>
                <label className=''>Action</label>
              </div>
              <div className='review-collection-scroll' style={{ maxHeight: 'calc(100vh - 430px)' }}>
                {userIntegration && userIntegration.length > 0 ?
                  userIntegration.map((usInt, key) => {
                    if (usInt._id == data.usIntId) usInt.ia = data.intISActive ? data.intISActive : false;
                    // let defaultChecked = arrDataSource.filter((dataSource) => {
                    //   if (dataSource.uid == usInt._id && dataSource.pid == usInt._id) return true; return false;
                    // }).length > 0 ? true : false;
                    // let objCountParams = {
                    //   pglkcnt: 0,
                    //   pgflcnt: 0,
                    //   pgrtngcnt: usInt.d.totalReview,
                    //   pgrtngavg: usInt.d.overallRating,
                    //   pu: '',
                    //   iin: usInt.inm,
                    //   rmk: usInt.rmk,
                    //   url: usInt.d.url,
                    //   dn: usInt.d.dn ? usInt.d.dn : ''
                    // };

                    return (new RegExp(data.searchByName, 'i').test(usInt.rmk) == true && <div className="card-editor card-intigra-block card-intigra-ggpalceislist" key={key}>
                      <div className="integra-checklist-item" >
                        {/* <div className="secstyle-checkbox secstyle-checkbox-sm  itgtion-icon-checkboc ">
                      <label>
                        <input type="checkbox"
                          name={usInt.d.productId}
                          checked={defaultChecked}
                          onChange={(e) => handleDataSource(
                            usInt._id,
                            usInt._id,
                            e.target.checked,
                            objCountParams,
                            usInt
                          )}
                        />
                      </label>
                    </div> */}
                        <span className="">{usInt.rmk}</span>
                        <div className='collection-group-action  d-flex align-items-center'>
                          {usInt.d.isListen === true && <div className='nf-btn btn-style-notbtn' >
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
                              <path id="Path_59480" data-name="Path 59480" d="M9.031-16.406a.654.654,0,0,1-.656.656.654.654,0,0,1-.656-.656v-2.187a.654.654,0,0,1,.656-.656.654.654,0,0,1,.656.656Zm0,10.5a.654.654,0,0,1-.656.656.654.654,0,0,1-.656-.656V-8.094a.654.654,0,0,1,.656-.656.654.654,0,0,1,.656.656ZM1.375-12.25a.654.654,0,0,1,.656-.656H4.219a.654.654,0,0,1,.656.656.654.654,0,0,1-.656.656H2.031A.654.654,0,0,1,1.375-12.25Zm13.344-.656a.654.654,0,0,1,.656.656.654.654,0,0,1-.656.656H12.531a.654.654,0,0,1-.656-.656.654.654,0,0,1,.656-.656ZM13.324-17.2a.66.66,0,0,1,0,.93l-1.531,1.559a.66.66,0,0,1-.93,0,.629.629,0,0,1,0-.93L12.395-17.2A.66.66,0,0,1,13.324-17.2ZM4.355-7.3a.694.694,0,0,1-.957,0,.7.7,0,0,1,0-.93L4.984-9.762a.629.629,0,0,1,.93,0,.627.627,0,0,1,0,.9ZM3.4-17.2a.694.694,0,0,1,.957,0l1.559,1.559a.66.66,0,0,1,0,.93.66.66,0,0,1-.93,0L3.4-16.27A.7.7,0,0,1,3.4-17.2ZM13.324-8.23a.66.66,0,0,1,0,.93.66.66,0,0,1-.93,0L10.863-8.859a.6.6,0,0,1,0-.9.629.629,0,0,1,.93,0Z" transform="translate(-1.375 19.25)" fill="#fff" />
                            </svg>&nbsp;
                            Fetching review
                          </div>}
                          {/* {usInt.d.isListen === true &&
                            <span className='btn-action nf-btn light-bg-icon btn-icon-20 tbl-action-rotet'>
                              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 20 19.996">
                                <path id="Path_59553" data-name="Path 59553" d="M52,17.379v6.207a1.378,1.378,0,0,1-1.379,1.379H44.414a1.379,1.379,0,0,1,0-2.759h2.732a6.886,6.886,0,1,0-5.5,11.026,6.83,6.83,0,0,0,4.133-1.377,1.38,1.38,0,0,1,1.657,2.206A9.565,9.565,0,0,1,41.652,36a9.651,9.651,0,1,1,7.59-15.59V17.379a1.379,1.379,0,1,1,2.759,0Z" transform="translate(-32 -16)" fill="#8392a5" />
                              </svg>
                            </span>
                          } */}
                          {usInt.d.isListen === false && <span className="btn-action nf-btn light-bg-icon btn-icon-20  tbl-action-dlt"
                            onClick={() => openReviewModel(usInt)}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="12.414" height="7.4" viewBox="0 0 12.414 7.4">
                              <path id="Path_14253" data-name="Path 14253" d="M6.207,98.725A7.744,7.744,0,0,0,.1,102.13a.491.491,0,0,0,0,.587,7.74,7.74,0,0,0,6.11,3.408,7.744,7.744,0,0,0,6.11-3.405.491.491,0,0,0,0-.587A7.74,7.74,0,0,0,6.207,98.725Zm.17,6.305A2.611,2.611,0,1,1,8.812,102.6,2.613,2.613,0,0,1,6.377,105.03Zm-.079-1.2a1.406,1.406,0,1,1,1.313-1.313A1.4,1.4,0,0,1,6.3,103.827Z" transform="translate(0 -98.725)" fill="#8392a5" />
                            </svg>
                          </span>}
                          <span className="btn-action nf-btn  btn-delete-light  light-bg-icon btn-icon-20  tbl-action-dlt"
                            onClick={() => deleteCapterra(usInt._id)}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 176 192">
                              <g id="Group_8307" data-name="Group 8307" transform="translate(-8)">
                                <path id="Path_12759" data-name="Path 12759" d="M128,32V24A24.027,24.027,0,0,0,104,0H88A24.027,24.027,0,0,0,64,24v8H8V48H184V32ZM80,24a8.009,8.009,0,0,1,8-8h16a8.009,8.009,0,0,1,8,8v8H80Z" fill="#fb5360" />
                                <path id="Path_12760" data-name="Path 12760" d="M30.467,170.651A23.976,23.976,0,0,0,54.321,192h83.358a23.976,23.976,0,0,0,23.854-21.35L174.272,56H17.728Zm87.561-99.316,15.944,1.33-8,96-15.944-1.33Zm-44.056,0,8,96-15.944,1.33-8-96Z" fill="#fb5360" />
                              </g>
                            </svg>
                          </span>
                        </div>
                        {/* <span className="btn-action nf-btn light-bg-icon btn-icon-20  tbl-action-dlt"
                      onClick={() => syncReviews(usInt._id)}>
                      <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
                        width="12" height="12" viewBox="0 0 384.000000 371.000000"
                        preserveAspectRatio="xMidYMid meet">
                        <g transform="translate(0.000000,371.000000) scale(0.100000,-0.100000)"
                          fill="#000000" stroke="none">
                          <path d="M1911 3700 c-30 -4 -66 -17 -80 -27 -31 -23 -71 -97 -71 -133 0 -49 42 -113 88 -137 40 -20 53 -21 190 -16 286 10 543 -59 780 -208 l65 -41 115 115 114 115 -93 61 c-183 120 -398 209 -614 251 -122 24 -399 35 -494 20z" />
                          <path d="M468 3245 c-337 -48 -371 -55 -402 -78 -86 -66 -87 -187 -3 -251 19 -15 50 -29 69 -32 28 -5 198 14 290 32 27 5 26 4 -29 -88 -322 -534 -360 -1196 -99 -1752 185 -395 554 -755 956 -932 151 -66 373 -134 443 -134 l28 0 -3 157 -3 157 -50 14 c-270 72 -467 173 -670 344 -274 229 -451 526 -526 878 -31 143 -33 417 -5 565 34 186 126 424 214 558 l27 41 6 -75 c4 -41 7 -115 8 -164 1 -72 6 -100 24 -135 44 -89 156 -114 235 -54 64 50 65 58 53 434 -6 184 -14 363 -17 397 -9 96 -60 158 -139 167 -22 2 -205 -19 -407 -49z" />
                          <path d="M3362 2867 l-112 -112 36 -59 c91 -152 165 -326 205 -483 l24 -93 157 0 c185 0 172 -14 134 145 -54 219 -152 448 -269 629 -31 47 -58 86 -59 86 -2 0 -54 -51 -116 -113z" />
                          <path d="M3515 1578 c-2 -7 -9 -38 -16 -68 -33 -148 -113 -337 -203 -475 l-45 -70 111 -112 c61 -62 116 -109 121 -106 19 12 132 193 182 294 66 130 115 270 149 421 14 64 26 118 26 122 0 3 -72 6 -160 6 -120 0 -162 -3 -165 -12z" />
                          <path d="M2830 559 c-136 -91 -316 -171 -482 -213 l-93 -23 -3 -162 -3 -163 33 7 c207 41 368 95 528 175 92 47 272 159 283 177 3 5 -44 60 -106 121 l-112 112 -45 -31z" />
                        </g>
                      </svg>
                    </span> */}
                      </div>
                      {usInt.d.isListen === true && <div className='text-review-min'>
                        It can take several minutes to fetch your review
                      </div>}
                    </div>);

                    // return (new RegExp(data.searchByName, 'i').test(usInt.rmk) == true && <div className="card-editor card-intigra-block card-intigra-palceislist" key={key}>
                    //   <div className="card-editor-block p-0">
                    //     <label className="card-editor-title app-intigra-title">{usInt.d.name}</label>
                    //     <div className="app-editor-actiontop app-intigra-actiontop">
                    //       <span className="btn-action nf-btn  btn-delete-light  light-bg-icon btn-icon-20  tbl-action-dlt"
                    //         onClick={() => deleteCapterra(usInt._id)}>
                    //         <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 176 192">
                    //           <g id="Group_8307" data-name="Group 8307" transform="translate(-8)">
                    //             <path id="Path_12759" data-name="Path 12759" d="M128,32V24A24.027,24.027,0,0,0,104,0H88A24.027,24.027,0,0,0,64,24v8H8V48H184V32ZM80,24a8.009,8.009,0,0,1,8-8h16a8.009,8.009,0,0,1,8,8v8H80Z" fill="#fb5360" />
                    //             <path id="Path_12760" data-name="Path 12760" d="M30.467,170.651A23.976,23.976,0,0,0,54.321,192h83.358a23.976,23.976,0,0,0,23.854-21.35L174.272,56H17.728Zm87.561-99.316,15.944,1.33-8,96-15.944-1.33Zm-44.056,0,8,96-15.944,1.33-8-96Z" fill="#fb5360" />
                    //           </g>
                    //         </svg>
                    //       </span>
                    //     </div>
                    //     <div className="card-intigra-box">
                    //       <div className="dataset-select-list">
                    //         <div className="dataset-select-item">
                    //           <div className="secstyle-checkbox  itgtion-icon-checkboc">
                    //             <label>
                    //               <input type="checkbox"
                    //                 name={usInt.d.productId}
                    //                 checked={defaultChecked}
                    //                 onChange={(e) => handleDataSource(
                    //                   usInt._id,
                    //                   usInt.d.productId,
                    //                   e.target.checked,
                    //                   objCountParams
                    //                 )}
                    //               />
                    //             </label>
                    //             <span>{usInt.rmk}</span>
                    //           </div>
                    //         </div>
                    //       </div>
                    //     </div>
                    //   </div>
                    // </div>);
                  }) :
                  <div className="card-editor card-intigra-block card-intigra-ggpalceislist">
                    <div className="dataset-select-item">
                      <h5> No record found</h5>
                    </div>
                  </div>}
              </div>


            </div>
          </div>}
      </div>
    </div>
  );
};


export default Capterra;


// WEBPACK FOOTER //
// ./src/components/Integration/Capterra.js